define('viewmodels/modals/dialogs/ChooseAccountDialog',[],function () {

    var ChooseAccountDialog = function(dialog, getField, accounts) {
        this.accounts = accounts;
        this.dialog = dialog;

        this.title = getField('choose_account_title');
        this.chooseNewAccountLinkText = getField('choose_account_link_text');
        this.signUpLinkText = getField('sign_up_link_text');

    };

    ChooseAccountDialog.prototype.chooseAccount = function(account) {
        this.dialog.close(this, account);
    };

    ChooseAccountDialog.prototype.chooseNoAccount = function() {
        this.dialog.close(this, null);
    };

    ChooseAccountDialog.prototype.close = function() {
        this.dialog.close(this);
    };

    return ChooseAccountDialog;
});

